// src/components/store/sections/blog-posts/BlogV6MinimaljournalCrimsonRose.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV6MinimaljournalCrimsonRose(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={6}
      archKey="minimal_journal"
      archLabel="Minimalist Journal Strip"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
